export default "__VITE_ASSET__BnjAW8nU__"